import type {
  WebUserGetCurrentOutputDto,
  WebUserGetInfoOutputDto,
} from '@bldsoft/ovp-api-types'
import type { OVPUserInfo, OVPUserSessionData } from '@setplex/tria-api'

export const formatSessionData = ({
  firstName,
  lastName,
  username,
  email,
  emailVerified,
  needFinishRegistration,
}: WebUserGetCurrentOutputDto): OVPUserSessionData => ({
  firstName,
  lastName,
  username,
  email,
  emailVerified,
  needFinishRegistration,
})

export const formatUserInfo = ({
  ip,
  location,
  userGuid,
  profile,
  primaryRegion,
  primaryRegionObject,
  primaryLanguageIso,
}: WebUserGetInfoOutputDto): OVPUserInfo => ({
  ip,
  location,
  userGuid,
  profile,
  primaryRegion,
  primaryRegionObject,
  primaryLanguageIso,
})
